/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Noorganizationcreate3Inputs */

const zh_organizationsettings_noorganizationcreate3 = /** @type {(inputs: Organizationsettings_Noorganizationcreate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建组织`)
};

const en_organizationsettings_noorganizationcreate3 = /** @type {(inputs: Organizationsettings_Noorganizationcreate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create organization`)
};

const es_organizationsettings_noorganizationcreate3 = /** @type {(inputs: Organizationsettings_Noorganizationcreate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear organización`)
};

/**
* | output |
* | --- |
* | "Create organization" |
*
* @param {Organizationsettings_Noorganizationcreate3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_noorganizationcreate3 = /** @type {((inputs?: Organizationsettings_Noorganizationcreate3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Noorganizationcreate3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_noorganizationcreate3(inputs)
	if (locale === "en") return en_organizationsettings_noorganizationcreate3(inputs)
	return es_organizationsettings_noorganizationcreate3(inputs)
});
export { organizationsettings_noorganizationcreate3 as "organizationSettings_noOrganizationCreate" }